<script>
    let list_gear = [
        ['Desk', 'Stand-up desk'],
        ['Mice', 'SteelSeries Rival 710'],
        ['Keyboard', 'Keychron Q6 (Gateron G Pro Brown, UK layout + knob)'],
        ['Headphones', 'Beyerdynamic DT 770 PRO 250 Ohm'],
        ['Mic', [
            'Rode PodMic (Rode WS2)',
            'sE Electronics DM1 Dynamite',
            'Rode AI-1',
            'Rode PSA1'
        ].join('<br>')],
        ['Monitor', [
            'MSI MPG321QRF-QD - 32", 1440p, 144Hz',
            'MSI G274QPF-QD - 27”, 1440p, 144Hz (2x)',
        ].join('<br>')],
        ['WebCam', 'Elgato Facecam'],
        ['CapCard', 'Elgato Game Capture 4K60 Pro']
    ];

    let list_pc = [
        ['MB', 'ASUS ROG CROSSHAIR VIII HERO (WI-FI)'],
        ['CPU', 'AMD Ryzen 9 5900X'],
        ['Cooler', 'NZXT Kraken X62'],
        ['GPU', 'GIGABYTE AORUS RTX 3090 XTREME 24G'],
        ['PSU', 'Seasonic Prime TX-1000'],
        ['RAM', 'G.SKILL Trident Z RGB Neo 32GB 3600MHz CL16'],
        ['SSD', [
            'Samsung SSD 960 PRO (M.2) - 512GB',
            'Intel SSD 660p (M.2) - 1TB',
            'Samsung 870 EVO (SATA) - 2TB',
            'Crucial MX500 (SATA) - 2TB'
        ].join('<br>')],
        /* ['HDD', [
            'Seagate Desktop HDD - 3TB',
            'Seagate BarraCuda - 6TB'
        ].join('<br>')], */
        ['Case', 'PHANTEKS Eclipse P600S Silent']
    ];
</script>

<style>
    /* .list + .block-title {
        margin-top: 40px;
    } */

    .list:not(:last-child) {
        margin-bottom: 40px;
    }

    .list-item {
        display: flex;
    }

    .list-item .item-name {
        flex-shrink: 0;
        width: 100px;
        text-align: right;
        color: #aaa;
    }

    .list-item .item-value {
        padding-left: 10px;
    }

    .list-item:not(:first-child) {
        margin-top: 5px;
    }

    @media only screen and (max-width: 420px) {
        .list-item {
            display: block;
        }

        .list-item .item-name {
            width: auto;
            text-align: left;
        }
    }
</style>

<div class="block-title">
    <h2>Equipment</h2>
</div>

<div class="list">
    {#each list_gear as [key, value]}
        <div class="list-item">
            <div class="item-name">{key}</div>
            <div class="item-value">{@html value}</div>
        </div>
    {/each}
</div>

<div class="block-title">
    <h2>PC</h2>
</div>

<div class="list">
    {#each list_pc as [key, value]}
        <div class="list-item">
            <div class="item-name">{key}</div>
            <div class="item-value">{@html value}</div>
        </div>
    {/each}
</div>
